module.exports = __webpack_public_path__ + "img/arrowFull_right_b.d86904e5.svg";